import React from "react";
import { Typography } from "@mui/material";
import moment from "moment";

const CopyrightMessage = () => {
  const currentYear = moment().format("YYYY");
  return (
    <Typography
      variant="caption"
      color="textSecondary"
    >{`Copyright \u{00A9} 2009-${currentYear} Grace Hill, Inc. All Rights Reserved.`}</Typography>
  );
};

export default CopyrightMessage;
